import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Reconciliation from "./bankRecon";

import "./bankRecon.css";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Reconciliation />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;